var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"note",on:{"click":function($event){return _vm.showHint(true)}}}),_vm._v(" "),_c('div',{staticClass:"note-bubble",class:{ active: _vm.active },on:{"click":function($event){return _vm.showHint(false)}}},[_c('p',[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_c('div',{staticClass:"note-bubble__close"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38df8e96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assetComponents/Note.vue
// module id = 315
// module chunks = 0